import React, { FC } from 'react'

import { TableNutrition } from '../TableNutrition'
import { DetailCardChart } from '../common/DetailCardChart'

import { AddEatableToJournal } from 'Components/DetailCardEatable/components/AddEatableToJournal'
import RichTextPanel from 'Components/RichTextPanel/RichTextPanel'
import { Food, QuantifiedFood } from 'Models'

interface Props {
  food: Food
  quantifiedFood?: QuantifiedFood
}

const DetailCardFoodContent: FC<Props> = ({ food, quantifiedFood }: Props) => {
  const isAddingToJournalPossible =
    window.location.pathname.includes('favoriten') || window.location.pathname.includes('mein-essen')

  return (
    <>
      <div className="px-5 pt-4 pb-4">
        <h1>{food.name}</h1>
      </div>

      {isAddingToJournalPossible && (
        <div className="hiddenInPrint px-5 mb-5">
          <AddEatableToJournal food={food} quantifiedEatable={quantifiedFood} />
        </div>
      )}

      <div className="mx-5 mb-3 pt-4">
        <div className="row">
          <div className="col-12 col-lg-6">
            <TableNutrition nutritionsPer100g={food.nutritions} />
          </div>

          <div className="col-12 col-lg-6 d-flex my-3 align-items-center justify-content-center">
            <DetailCardChart nutritionsPerWeight={food.nutritions || {}} />
          </div>
        </div>
      </div>

      <div className="p-5">
        <div className="row">
          {food.description && (
            <>
              <div className="col-12">
                <h2>Beschreibung</h2>
              </div>

              <div className="col-12 mt-1">
                <RichTextPanel text={food.description} />
              </div>
            </>
          )}

          {food.ingredients && (
            <div className="col-12 mb-2">
              <h2>Inhaltsstoffe / Zutaten</h2>

              <p className="mt-3">{food.ingredients}</p>
            </div>
          )}

          {food.source && (
            <div className="col-12 mt-1">
              <p>
                <em>Quelle: {food.source.name}</em>
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default DetailCardFoodContent
